import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const WarrantyEmpty = () => {
	const { t } = useTranslation(['warranty']);

	return <Typography>{t('unavailable')}</Typography>;
};
